// import { Breakpoint } from '@shared/models/interfaces/breakpoint.interface';
import { AccountResponseDto, TermsResponseDto } from '@core/api/generated/accounts/v1';
import { FiltersDto } from '@domain/dtos/filters.dto';
import { ActionReducerMap } from '@ngrx/store';
import { MenuItem } from '@shared/models/interfaces/menu-item.interface';
import { Vehicle } from '../../features/vehicles/domain/vehicle.model';
// import { MenuItem } from '@shared/models/interfaces/menu-item.interface';

// import { breakpointReducer } from './reducers/breakpoint.reducer';
// import { menuItemsReducer } from './reducers/menu-items.reducer';
import { activityPaymentsFiltersReducer } from './reducers/activity-payments-filters.reducer';
import { activityTollsFiltersReducer } from './reducers/activity-tolls-filters.reducer';
import { legalTermsReducer } from './reducers/legal-terms.reducer';
import { menuItemsReducer } from './reducers/menu-items.reducer';
import { userReducer } from './reducers/user.reducer';
import { vehicleReducer } from './reducers/vehicle.reducer';

export interface IAppState {
    menuItemsState: MenuItem[];
    userState: AccountResponseDto;
    vehicleState: Vehicle;
    legalTermsState: TermsResponseDto;
    activityTollsState: FiltersDto;
    activityPaymentsState: FiltersDto;
    // breakpointState: Breakpoint;
}

export const APP_REDUCERS: ActionReducerMap<IAppState> = {
    menuItemsState: menuItemsReducer,
    userState: userReducer,
    vehicleState: vehicleReducer,
    legalTermsState: legalTermsReducer,
    activityTollsState: activityTollsFiltersReducer,
    activityPaymentsState: activityPaymentsFiltersReducer,
    // breakpointState: breakpointReducer,
};
